import { render } from "./ReferralStoreFeesModal.vue?vue&type=template&id=ece8f4de&scoped=true&ts=true"
import script from "./ReferralStoreFeesModal.vue?vue&type=script&lang=ts"
export * from "./ReferralStoreFeesModal.vue?vue&type=script&lang=ts"

import "./ReferralStoreFeesModal.vue?vue&type=style&index=0&id=ece8f4de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ece8f4de"]])

export default __exports__